module.exports = __webpack_public_path__ + "img/signIn_list2.412078a6.png";